import { render, staticRenderFns } from "./EditRate.vue?vue&type=template&id=a65ff660"
import script from "./EditRate.vue?vue&type=script&lang=js"
export * from "./EditRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports